import { createContext } from 'react';
import { Place } from 'utils/interfaces/announcementForm';

export type PlaceContextType = {
   place: Place | null;
   changePlace: (placeId: string, placeName?: string) => void;
};

const PlaceContext = createContext<PlaceContextType>({
   place: null,
   changePlace: placeId => {}, // eslint-disable-line
});

export default PlaceContext;
